// components/SignatureFormsTimeline.tsx

import {Button, ButtonGroup, Dropdown, Spinner} from 'react-bootstrap'
import {useState} from 'react'
import moment from 'moment'
import {
  AllSignatureFormsEntries,
  NodeSignatureFormsEntry,
} from '../../../types/signatureFormsEntriesApi'
import {useDisclourse} from '../../../hooks/useDisclourse'
import {parseId} from '../../../helpers'
import {BadgeStatus} from '../../signatureFormsEntries/components/BadgeStatus'
import {ModalPreview} from '../../signatureFormsEntries/components/ModalPreview'
import {ModalRequestSignature} from '../../signatureForms/components/ModalRequestSignature'
import {AgentInfoTooltip} from '../../shared/AgentInfoTooltip'
import {UserAvatar} from '../../../components/UserAvatar'
import {useMutation} from '@apollo/client'
import {DELETE_SIGNATURE_FORM_ENTRY} from '../../../gql/mutations/signatureFormsMutations'
import {toast} from 'react-toastify'
import {ModalDeleteSignatureEntry} from './ModalDeleteSignatureEntry'

interface SignatureFormsEntriesTimelineProps {
  dataEntriesByLead: AllSignatureFormsEntries | undefined
  loading: boolean
  refetch: () => void
  emptyMessage?: string
  hasEmail?: boolean
  hasPhone?: boolean
  compact?: boolean
}

export const SignatureFormsEntriesTimeline: React.FC<SignatureFormsEntriesTimelineProps> = ({
  dataEntriesByLead,
  loading,
  refetch,
  emptyMessage = 'There are no consent requests',
  hasEmail,
  hasPhone,
  compact = false,
}) => {
  console.log('TLRC  hasEmail:' + hasEmail + ' hasPhone:' + hasPhone)
  const [infoPreview, setInfoPreview] = useState<null | NodeSignatureFormsEntry>(null)
  const {isOpen: isOpenPreview, onClose: onClosePreview, onOpen: onOpenPreview} = useDisclourse()
  const {isOpen: isOpenRequest, onClose: onCloseRequest, onOpen: onOpenRequest} = useDisclourse()
  const {
    isOpen: isOpenDelete,
    onClose: onCloseDelete,
    onOpen: onOpenDelete,
  } = useDisclourse()
  const [entryToDelete, setEntryToDelete] = useState<NodeSignatureFormsEntry | null>(null)
  const [deleteSignatureEntry, {loading: deletingEntry}] = useMutation(DELETE_SIGNATURE_FORM_ENTRY)
  // const [signingUrl, setSigningUrl] = useState<string>()

  // const [
  //   resendSignatureEntry,
  //   {data: dataCreateSFE, loading: loadingCreateSFE, error: errorCreateSFE},
  // ] = useMutation(RESEND_SIGNATURE_FORM_ENTRY)

  // const handleResend = (id: string) => {
  //   resendSignatureEntry({
  //     variables: {
  //       entryId: '' + parseId(id), // o tu variable dinámica
  //       shouldSendEmail: true,
  //       sendSms: false,
  //       getSigningLink: false,
  //     },
  //   })
  // }

  // useEffect(() => {
  //   const data = dataCreateSFE?.resendSignatureFormEntry
  //   if (!data) return

  //   if (data.ok) {
  //     const emailSent = data.emailSent
  //     const hasUrl = !!data.signingUrl

  //     if (!emailSent && !hasUrl) {
  //       toast.warning(
  //         `The request was ignored. ${data.errorMessage || 'No email sent and no link requested.'}`
  //       )
  //       return
  //     }

  //     if (emailSent) {
  //       toast.success('Email sent successfully')
  //     }

  //     if (hasUrl) {
  //       setSigningUrl(data.signingUrl)
  //       // onOpenResend()
  //     }

  //     refetch()
  //   } else {
  //     toast.error(`Error: ${data.errorMessage || 'Something went wrong'}`)
  //   }
  // }, [dataCreateSFE])

  const handleDeleteEntry = async () => {
    if (!entryToDelete) return

    try {
      const parsedId = String(parseId(entryToDelete.id))
      const {data} = await deleteSignatureEntry({
        variables: {
          entryId: parsedId,
        },
      })

      if (data?.deleteSignatureFormEntry?.ok) {
        toast.success('Signature request deleted')
        onCloseDelete()
        setEntryToDelete(null)
        refetch()
      } else {
        toast.error(data?.deleteSignatureFormEntry?.errorMessage || 'Unable to delete signature request')
      }
    } catch (error) {
      console.error('Error deleting signature form entry', error)
      toast.error('Error deleting signature request')
    }
  }

  const data = dataEntriesByLead?.edges ?? []

  return (
    <>
      <div className='table-responsive'>
        <table
          className={`table table-striped table-hover align-middle ${compact ? 'table-sm' : ''}`}
          style={{tableLayout: 'fixed', width: '100%'}}
        >
          <colgroup>
            <col style={{width: compact ? '14%' : '12%'}} />
            <col style={{width: compact ? '18%' : '16%'}} />
            <col style={{width: '14%'}} />
            <col style={{width: '16%'}} />
            <col style={{width: '16%'}} />
            <col style={{width: '10%'}} />
            <col style={{width: '18%'}} />
            <col style={{width: '12%'}} />
          </colgroup>
          <thead style={compact ? { fontSize: '0.875rem' } : undefined}>
            <tr>
              <th className='fw-bold'>Agent</th>
              <th className='fw-bold'>Recipient</th>
              <th className='fw-bold'>Status</th>
              <th className='fw-bold'>Requested on</th>
              <th className='fw-bold'>Signed on</th>
              <th className='fw-bold'>Signed from</th>
              <th className='fw-bold'>Form name</th>
              <th className='fw-bold'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8}>
                  <div className='d-flex flex-center' style={{ height: compact ? '120px' : '30vh' }}>
                    <Spinner animation='border' />
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={8}>
                  <div
                    className='d-flex flex-center'
                    style={{
                      height: compact ? '48px' : '30vh',      // 2 líneas aprox
                      fontSize: compact ? '1rem' : undefined,  // 👈 evita letra chica en compact
                    }}
                  >
                    {emptyMessage}
                  </div>
                </td>
              </tr>
            ) : (
              data?.map(({node}) => (
                <tr key={node.id}>
                  <td className='text-center'>
                    <UserAvatar user={node.agent ?? null} tooltipId={`myt${node.id}`} size={compact ? 32 : 40} />
                    <AgentInfoTooltip id={`myt${node.id}`} user={node.agent ?? null} />
                  </td>
                  <td className='text-break'>
                    <span
                      className='text-primary'
                      style={{cursor: 'pointer'}}
                      data-tooltip-id={`myt2${parseId(node.id)}`}
                    >
                      {node.recipient}
                    </span>
                  </td>
                  <td className='text-break'>
                    <BadgeStatus state={node.status} />
                  </td>
                  <td className='text-break'>
                    {node.requestedOn ? (
                      <>
                        {moment(node.requestedOn).format('MMM DD, YYYY')}
                        <br />
                        <span style={{fontSize: 13, color: '#888'}}>
                          {moment(node.requestedOn).format('hh:mm a')}
                        </span>
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className='text-break'>
                    {node.signedOn ? (
                      <>
                        {moment(node.signedOn).format('MMM DD, YYYY')}
                        <br />
                        <span style={{fontSize: 13, color: '#888'}}>
                          {moment(node.signedOn).format('hh:mm a')}
                        </span>
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className='text-break'>-</td>
                  <td className='text-break'>{node.signatureForm?.name || '-'}</td>
                  <td className='text-center text-md-end'>
                    {/* {loadingCreateSFE && <Spinner animation='border' />} */}
                    {node.status === 'SIGNED' && (
                      <Dropdown as={ButtonGroup}>
                        <Button
                          variant='outline-primary'
                          size='sm'
                          style={{border: '1px solid #3e97ff'}}
                          onClick={() => {
                            onOpenPreview()
                            setInfoPreview(node)
                          }}
                        >
                          <i className='bi bi-arrows-angle-expand fs-2' />
                          Preview
                        </Button>
                      </Dropdown>
                    )}

                    {node.status !== 'SIGNED' && (
                      <Dropdown>
                        <Dropdown.Toggle variant='outline' size='sm' id='dropdown-basic'>
                          Options
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              onOpenPreview()
                              setInfoPreview(node)
                            }}
                          >
                            <span className='d-flex align-items-center gap-4'>
                              <i className='bi bi-arrows-angle-expand fs-2' />
                              <span>Preview</span>
                            </span>
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setInfoPreview(node)
                              onOpenRequest()
                              // handleResend(node.id)
                            }}
                          >
                            <span className='d-flex align-items-center gap-4'>
                              <i className='bi bi-arrow-right-square fs-2' />
                              <span>Resend</span>
                            </span>
                          </Dropdown.Item>
                          {node.status === 'PENDING' && (
                            <Dropdown.Item
                              className='text-danger'
                              onClick={() => {
                                setEntryToDelete(node)
                                onOpenDelete()
                              }}
                            >
                              <span className='d-flex align-items-center gap-4'>
                                <i className='bi bi-trash3 fs-2' />
                                <span>Delete</span>
                              </span>
                            </Dropdown.Item>
                          )}
                          {/* <Dropdown.Item
                            disabled={data.status !== STATUS_POLICY.PENDING}
                            onClick={() => {
                              onOpenMemberId()
                            }}
                          >
                            <span className='d-flex align-items-center gap-2'>
                              <i className='bi bi-person-fill-up fs-2' style={{color: 'purple'}} />
                              <span>{data.memberId ? 'Edit' : 'Add'} Member ID</span>
                            </span>
                          </Dropdown.Item> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {isOpenPreview && infoPreview && (
          <ModalPreview
            info={infoPreview}
            isOpen={isOpenPreview}
            onClose={onClosePreview}
            refetch={refetch}
          />
        )}
        {isOpenRequest && (
          <ModalRequestSignature
            keyboard={false}
            backdrop='static'
            isOpen={isOpenRequest}
            sourceId={infoPreview?.leadId?.id ?? ''}
            sourceType='lead'
            onClose={onCloseRequest}
            refetch={refetch}
            hasEmail={hasEmail}
            hasPhone={hasPhone}
            preAgentId={infoPreview?.agent?.id ?? infoPreview?.user.id}
            resendEntryId={infoPreview ?? undefined}
          />
        )}
        {entryToDelete && (
          <ModalDeleteSignatureEntry
            entry={entryToDelete}
            isOpen={isOpenDelete}
            loading={deletingEntry}
            onClose={() => {
              if (deletingEntry) return
              onCloseDelete()
              setEntryToDelete(null)
            }}
            onConfirm={handleDeleteEntry}
          />
        )}
      </div>
    </>
  )
}
